import Colors from '../../../../assets/Colors'

const addDriverStyles = {
  modalTitle: {
    height: '32px',
    fontFamily: 'NAPA SANS',
    fontWeight: '700',
    fontSize: '25px',
    lineHeight: '32px',
    letterSpacing: '0.4px',
    color: Colors.napaBlue
  },
  addDriverModalContainer: {
    width: '395px',
    alignItems: 'center',
    padding: '16px',
    backgroundColor: Colors.white,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '3px'
  },
  addDriverModal: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    width: '100%'
  },
  addDriverTextField: {
    width: '363px',
    marginBottom: '10px'
  },
  addDriverLabel: {
    fontFamily: 'NAPA SANS',
    fontWeight: '700',
    fontSize: '14px',
    letterSpacing: '0.36px',
    marginBottom: '5px',
    color: Colors.black
  },
  phoneNumberField: {
    border: '1px',
    borderStyle: 'solid',
    borderRadius: '4px',
    width: '337px',
    padding: '12px',
    textAlign: 'center',
    svg: {
      height: '20px'
    }
  },
  inputContainer: {
    paddingY: '5px'
  },
  errorText: {
    color: '#D32F2F',
    fontSize: 12,
    marginLeft: '14px',
    marginBottom: '5px',
    marginTop: '3px'
  }
}

export default addDriverStyles
